import {Breakpoints, styled} from '@vw-marketing/us-components';

export const StyledSimilarVehicles = styled.div`
  margin-top: 50px;
  width: 100%;

  .divider {
    height: 1px;
    background: #dfe4e8;
    margin: 14px 0;
  }

  @media screen and (min-width: ${Breakpoints.b960}px) {
    margin-top: 80px;

    .divider {
      width: 100%;
      order: 1;
    }
  }
`;
